import request from '@/utils/request'

export function getHorseList(params) {
  return request({
    url: '/api/admin/Horse',
    method: 'get',
    params
  })
}

export function getHorseDetail(id) {
  return request({
    url: `/api/admin/Horse/${id}`,
    method: 'get'
  })
}

export function getActiveHorses() {
  return request({
    url: '/api/admin/Horse/active',
    method: 'get'
  })
}

export function createHorse(data) {
  return request({
    url: '/api/admin/Horse',
    method: 'post',
    data
  })
}

export function updateHorse(id, data) {
  return request({
    url: `/api/admin/Horse/${id}`,
    method: 'put',
    data
  })
}

export function deleteHorse(id) {
  return request({
    url: `/api/admin/Horse/${id}`,
    method: 'delete'
  })
}
